import { render } from "./Sidenav.vue?vue&type=template&id=7643bc95&scoped=true&ts=true"
import script from "./Sidenav.vue?vue&type=script&lang=ts"
export * from "./Sidenav.vue?vue&type=script&lang=ts"

import "./Sidenav.vue?vue&type=style&index=0&id=7643bc95&scoped=true&lang=css"

import exportComponent from "/Users/georgemayer/Sites/apps/lognote/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7643bc95"]])

export default __exports__